<app-hero></app-hero>
<app-cservices></app-cservices>
<app-ideas></app-ideas>
<app-trust></app-trust>
<app-testimonials></app-testimonials>
<app-cnews></app-cnews>